import { ApiError } from "@softmax/observatory-client/transport";

import type { PublicPlayShell } from "../../lib/types";
import { type PlayApi } from "../../data/play-api";
import { boardLimit, playName } from "../one-pager-model";

import type { LeaderboardData } from "../types";

export async function readPublicBoard({
  api,
  shell,
}: {
  api: PlayApi;
  shell: PublicPlayShell;
}): Promise<LeaderboardData> {
  const leaderboard = shell.divisionId
    ? await api.divisionLeaderboard({
        divisionId: shell.divisionId,
        anonymous: await api.leagueIsPublic(shell.league.id),
      })
    : null;

  if (leaderboard?.status === "unavailable")
    throw new ApiError("Leaderboard unavailable.", 503);

  return {
    boardStatus: leaderboard?.status ?? "unpublished",
    board: (leaderboard?.status === "published"
      ? leaderboard.summary.entries
      : []
    )
      .slice(0, boardLimit)
      .map((entry) => ({
        rank: entry.rank,
        cogent: entry.player_name?.replace(playName, "") ?? "unnamed",
        owner: entry.owner_name ?? null,
        program: entry.policy_label ?? null,
        score: entry.score,
        mine: false,
      })),
    mineBelow: null,
  };
}
